import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from '@/layouts/dashboard.vue'
import EstadoGeneral from './home.vue'
import DialogoDesempeno from './dialogo-desempeno.vue'
import DialogoDesempenoHome from './dialogo-desempeno-home.vue'
import DialogoDesempenoEjecutar from './dialogo-desempeno-ejecutar.vue'
import DialogoDesempenoDetail from './dialogo-desempeno-detail.vue'
import ConfirmacionProcesos from './confirmacion-procesos.vue'
import ConfirmacionProcesosHome from './confirmacion-procesos-home.vue'
import ConfirmacionProcesosEjecutar from './confirmacion-procesos-ejecutar.vue'
import ConfirmacionProcesosDetail from './confirmacion-procesos-detail.vue'
import PSConsultor from './planificacion-semanal.vue'
import SeguimientoDiario from './seguimiento-diario.vue'
import SeguimientoDiarioHome from './seguimiento-diario-home.vue'
import SeguimientoDiarioDetail from './seguimiento-diario-detail.vue'
import SeguimientoDiarioEjecutar from './seguimiento-diario-ejecutar.vue'
import LoginView from './login.vue'
import ChangePwd from './changePwd.vue'
import PermissionView from './permission.vue'
import store from '../store'
import API from '../store/utils/api'
import ErrorView from './error.vue'
import VueJwtDecode from 'vue-jwt-decode'
import PSPendientes from './ps-pendientes.vue'
import PSObjetivos from './ps-objetivos.vue'
import Administracion from './administracion.vue'
import AdministracionHome from './administracion-home.vue'
import AdministracionUsuarios from './administracion-usuarios.vue'
import AdministracionUsuariosDetail from './administracion-usuarios-detail.vue'
import AdministracionUsuariosCrear from './administracion-usuarios-create.vue'
import AdministracionUsuariosMasivo from './administracion-usuarios-masivo.vue'
import ExcepcionCierrePlanificacion from './cierre-planificacion.vue'
import Reportes from './reportes.vue'
import Consultor from './consultor.vue'
import ConsultorHome from './consultor-home.vue'
import PautaDetail from './consultor-pauta-detail.vue'
import PautaAvance from './consultor-pauta-avance.vue'
import PautaResumen from './consultor-pauta-resumen.vue'
import PautaHistorial from './consultar-pauta-historial.vue'
import ConsultorPS from './consultor-planificacion-semanal.vue'
import ConsultorOC from './consultor-observaciones-calidad.vue'
import ConsultorH from './consultor-historico.vue'
import Historico from './historico.vue'
import AdministracionKpiAdherencia from './administracion-kpi.vue'
import AdministracionKpiCreate from './administracion-kpi-create.vue'
import AdministracionKpiEdit from './administracion-kpi-edit.vue'
import AdministracionKpiBusinessType from './administracion-business-type.vue'
import AdministracionKpiNegocioCreate from './administracion-business-type-create.vue'
import AdministracionKpiNegocioEdit from './administracion-business-type-edit.vue'
import AdministracionRole from './administracion-role.vue'
import AdministracionRoleCreate from './administracion-role-create.vue'
import AdministracionRoleEdit from './administracion-role-edit.vue'
import AdministracionUsuariosReact from './administracion-usuarios-reactivate.vue'
import AdministracionProfile from './administracion-profile.vue'
import AdministracionProfileEdit from './administracion-profile-edit.vue'
import AdministracionProfileCreate from './administracion-profile-create.vue'
import ConfirmacionProcesosM from './cpmensual/cp-mensual.vue'
import ConfirmacionProcesosMHome from './cpmensual/cp-mensual-home.vue'
import ConfirmacionProcesosMEjecutar from './cpmensual/cp-mensual-ejecutar.vue'
import ConfirmacionProcesosMDetail from './cpmensual/cp-mensual-detail.vue'
import ConsultorPSExt from './consultor-externo/consultor-externo-planificacion-semanal.vue'
import ConsultorOCExt from './consultor-externo/consultor-externo-observaciones-calidad.vue'
import ConsultorHExt from './consultor-externo/consultor-externo-historico.vue'
import ConsultorExt from './consultor-externo/consultor-externo.vue'
import ConsultorHomeExt from './consultor-externo/consultor-externo-home.vue'
import PautaDetailExt from './consultor-externo/consultor-externo-pauta-detail.vue'
import PautaAvanceExt from './consultor-externo/consultor-externo-pauta-avance.vue'
import PautaResumenExt from './consultor-externo/consultor-externo-pauta-resumen.vue'
import PautaHistorialExt from './consultor-externo/consultor-externo-pauta-historial.vue'
import DashboardSessions from './consultor-externo/consultor-externo-dashboard.vue'
import KpiExterno from './kpi-externo/kpi-externo.vue'
import KpiExternoCreate from './kpi-externo/kpi-externo.create.vue'
import KpiExternoEdit from './kpi-externo/kpi-externo.edit.vue'
import ScaleValuesList from './scale-values/scale-values-list.vue'
import ScaleValuesEdit from './scale-values/scale-values-edit.vue'
import ScaleValuesCreate from './scale-values/scale-values-create.vue'
import CategoryExtList from './categoryexts/categoryext-list.vue'
import CategoryExtEdit from './categoryexts/categoryext-edit.vue'
import CategoryExtCreate from './categoryexts/categoryext-create.vue'
import GuidelineList from './guideline/guideline-list.vue'
import GuidelineEdit from './guideline/guideline-edit.vue'
import GuidelineCreate from './guideline/guideline-create.vue'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/change-password',
      name: 'ChangePwd',
      component: ChangePwd,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/',
      name: 'Login',
      component: LoginView,
      meta: {
        isPublic: true
      }
    },
    {
      path: '/permission',
      component: PermissionView,
      name: 'permission'
    },
    {
      path: '*',
      component: ErrorView
    },
    {
      path: '/home',
      component: Dashboard,
      children: [
        {
          path: '',
          name: 'Estado General',
          component: EstadoGeneral
        },
        {
          path: '/dialogo-desempeno/:id',
          name: 'Diálogos de Desempeño',
          component: DialogoDesempeno,
          children: [
            {
              path: '',
              name: 'Diálogo de desempeño',
              component: DialogoDesempenoHome
            },
            {
              path: 'detail',
              name: 'Detalle Diálogo de desempeño',
              component: DialogoDesempenoDetail
            },
            {
              path: 'ejecutar',
              name: 'Ejecutar Diálogo de Desempeño',
              component: DialogoDesempenoEjecutar,
            },
          ]
        },
        {
          path: '/planificacion-semanal',
          name: 'Planificación Semanal',
          component: PSConsultor,
        },
        {
          path: '/seguimiento-diario/:id',
          name: 'Seguimiento Diario',
          component: SeguimientoDiario,
          children: [
            {
              path: '',
              name: 'Seguimiento Diario',
              component: SeguimientoDiarioHome
            },
            {
              path: 'detail',
              name: 'Seguimiento Diario',
              component: SeguimientoDiarioDetail
            },
            {
              path: 'ejecutar',
              name: 'Seguimiento Diario Ejecutar',
              component: SeguimientoDiarioEjecutar,
            },
          ]
        },
        {
          path: '/confirmacion-procesos/:id',
          name: 'Confirmación de Procesos',
          component: ConfirmacionProcesos,
          children: [
            {
              path: '',
              name: 'Confirmación de Procesos',
              component: ConfirmacionProcesosHome
            },
            {
              path: 'detail',
              name: 'Confirmación de Procesos',
              component: ConfirmacionProcesosDetail
            },
            {
              path: 'ejecutar',
              name: 'Confirmación de Procesos Ejecutar',
              component: ConfirmacionProcesosEjecutar,
            },
          ]
        },
        {
          path: '/historico/:id',
          name: 'Histórico',
          component: Historico
        },
        {
          path: '/confirmacion-procesos-mensual/:id',
          name: 'Confirmación de Procesos Mensual',
          component: ConfirmacionProcesosM,
          children: [
            {
              path: '',
              name: 'Confirmación de Procesos Mensual',
              component: ConfirmacionProcesosMHome
            },
            {
              path: 'detail',
              name: 'Confirmación de Procesos Mensual',
              component: ConfirmacionProcesosMDetail
            },
            {
              path: 'ejecutar',
              name: 'CP Mensual Ejecutar',
              component: ConfirmacionProcesosMEjecutar,
            },
          ]
        }
      ]
    },
    {
      path: '/administracion/:id',
      name: 'Administración',
      component: Administracion,
      children: [
        {
          path: '/',
          name: 'Administración Home',
          component: AdministracionHome
        },
        {
          path: 'usuarios',
          name: 'Listar Usuarios',
          component: AdministracionUsuarios
        },
        {
          path: 'edit',
          name: 'Editar usuario',
          component: AdministracionUsuariosDetail
        },
        {
          path: 'view',
          name: 'Ver usuario',
          component: AdministracionUsuariosDetail
        },
        {
          path: 'create',
          name: 'Crear usuario',
          component: AdministracionUsuariosCrear
        },
        {
          path: 'masivo',
          name: 'Carga masiva usuarios',
          component: AdministracionUsuariosMasivo
        },
        {
          path: '/reportes',
          name: 'Reportes',
          component: Reportes,
          meta: {
            isPublic: false
          }
        },
        {
          path: '/excepcion-cierre-planificacion',
          name: 'Excepcion cierre planificacion',
          component: ExcepcionCierrePlanificacion,
          meta: {
            isPublic: false
          }
        },
        {
          path: 'kpi-adherencia',
          name: 'kpi adherencia',
          component: AdministracionKpiAdherencia,
          meta: {
            isPublic: false
          }
        },
        {
          path: 'kpi-adherencia-create',
          name: 'kpi adherencia create',
          component: AdministracionKpiCreate,
          meta: {
            isPublic: false
          }
        },
        {
          path: 'kpi-adherencia-edit',
          name: 'kpi adherencia edit',
          component: AdministracionKpiEdit,
          meta: {
            isPublic: false
          }
        },
        {
          path: 'kpi-negocio',
          name: 'kpi negocio',
          component: AdministracionKpiBusinessType,
          meta: {
            isPublic: false
          }
        },
        {
          path: 'kpi-negocio-create',
          name: 'kpi negocio create',
          component: AdministracionKpiNegocioCreate,
          meta: {
            isPublic: false
          }
        },
        {
          path: 'kpi-negocio-edit',
          name: 'kpi negocio edit',
          component: AdministracionKpiNegocioEdit,
          meta: {
            isPublic: false
          }
        },
        {
          path: 'role',
          name: 'role',
          component: AdministracionRole,
          meta: {
            isPublic: false
          }
        },
        {
          path: 'role-create',
          name: 'role create',
          component: AdministracionRoleCreate,
          meta: {
            isPublic: false
          }
        },
        {
          path: 'role-edit',
          name: 'role edit',
          component: AdministracionRoleEdit,
          meta: {
            isPublic: false
          }
        },
        {
          path: 'reactivate',
          name: 'Reactivate user',
          component: AdministracionUsuariosReact,
          meta: {
            isPublic: false
          }
        },
        {
          path: 'profile',
          name: 'profile',
          component: AdministracionProfile,
          meta: {
            idPublic: false
          }
        },
        {
          path: 'profile-edit',
          name: 'profile edit',
          component: AdministracionProfileEdit,
          meta: {
            idPublic: false
          }
        },
        {
          path: 'profile-create',
          name: 'profile create',
          component: AdministracionProfileCreate,
          meta: {
            idPublic: false
          }
        },
        {
          path: 'kpi-externo',
          name: 'kpi externo',
          component: KpiExterno,
          meta: {
            isPublic: false
          }
        },
        {
          path: 'kpi-externo-create',
          name: 'kpi externo create',
          component: KpiExternoCreate,
          meta: {
            isPublic: false
          }
        },
        {
          path: 'kpi-externo-edit',
          name: 'kpi externo edit',
          component: KpiExternoEdit,
          meta: {
            isPublic: false
          }
        },
        {
          path: 'scale-values-list',
          name: 'scale values list',
          component: ScaleValuesList,
          meta: {
            idPublic: false
          }
        },
        {
          path: 'scale-values-edit',
          name: 'scale values edit',
          component: ScaleValuesEdit,
          meta: {
            idPublic: false
          }
        },
        {
          path: 'scale-values-create',
          name: 'scale values create',
          component: ScaleValuesCreate,
          meta: {
            idPublic: false
          }
        },
        {
          path: 'categoryexts-list',
          name: 'categoryexts list',
          component: CategoryExtList,
          meta: {
            idPublic: false
          }
        },
        {
          path: 'categoryexts-edit',
          name: 'categoryexts edit',
          component: CategoryExtEdit,
          meta: {
            idPublic: false
          }
        },
        {
          path: 'categoryexts-create',
          name: 'categoryexts create',
          component: CategoryExtCreate,
          meta: {
            idPublic: false
          }
        },
        {
          path: 'guideline-list',
          name: 'guideline list',
          component: GuidelineList,
          meta: {
            idPublic: false
          }
        },
        {
          path: 'guideline-edit',
          name: 'guideline edit',
          component: GuidelineEdit,
          meta: {
            idPublic: false
          }
        },
        {
          path: 'guideline-create',
          name: 'guideline create',
          component: GuidelineCreate,
          meta: {
            idPublic: false
          }
        }
      ]
    },
    {
      path: '/consultor',
      name: 'Consultor',
      component: Consultor,
      children: [
        {
          path: '/',
          name: 'Consultor Home',
          component: ConsultorHome,
          meta: {
            isConsultor: true
          }
        },
        {
          path: '/pauta/:type/:id',
          name: 'Ver pauta',
          component: PautaDetail,
          meta: {
            isConsultor: true
          }
        },
        {
          path: '/pauta/avance/:id/:type/:collab',
          name: 'Ver avance',
          component: PautaAvance,
          meta: {
            isConsultor: true
          }
        },
        {
          path: '/resumen-pauta/:id',
          name: 'Resumen pautas',
          component: PautaResumen,
          meta: {
            isConsultor: true
          }
        },
        {
          path: '/historial-pauta/:id/:type/:collab',
          name: 'Historial pautas',
          component: PautaHistorial,
          meta: {
            isPublic: false
          }
        },
        {
          path: '/consultor-planificacion-semanal',
          name: 'Planificación semanal',
          component: ConsultorPS,
          meta: {
            isConsultor: true
          }
        },
        {
          path: '/consultor-observaciones-calidad',
          name: 'Observaciones Calidad',
          component: ConsultorOC,
          meta: {
            isConsultor: true
          }
        },
        {
          path: '/consultor-historico/:id',
          name: 'Histórico',
          component: ConsultorH,
          meta: {
            isConsultor: true
          }
        },
      ]
    },
    {
      path: '/consultor-externo',
      name: 'Consultor externo',
      component: ConsultorExt,
      children: [
        {
          path: '/',
          name: 'Consultor Home',
          component: ConsultorHomeExt,
          meta: {
            isConsultor: true
          }
        },
        {
          path: '/pauta/:type/:id',
          name: 'Ver pauta externo',
          component: PautaDetailExt,
          meta: {
            isConsultor: true
          }
        },
        {
          path: '/pauta/avance/:id/:type/:collab',
          name: 'Ver avance externo',
          component: PautaAvanceExt,
          meta: {
            isConsultor: true
          }
        },
        {
          path: '/resumen-pauta/:id',
          name: 'Resumen pautas externo',
          component: PautaResumenExt,
          meta: {
            isConsultor: true
          }
        },
        {
          path: '/historial-pauta/:id/:type/:collab',
          name: 'Historial pautas externo',
          component: PautaHistorialExt,
          meta: {
            isPublic: false
          }
        },
        {
          path: '/consultor-externo-planificacion-semanal',
          name: 'Planificación semanal externo',
          component: ConsultorPSExt,
          meta: {
            isConsultor: true
          }
        },
        {
          path: '/consultor-externo-observaciones-calidad',
          name: 'Observaciones Calidad Externo',
          component: ConsultorOCExt,
          meta: {
            isConsultor: true
          }
        },
        {
          path: '/consultor-externo-historico/:id',
          name: 'Histórico',
          component: ConsultorHExt,
          meta: {
            isConsultor: true
          }
        },
        {
          path: '/dashboard',
          name: 'Dashboard',
          component: DashboardSessions,
          meta: {
            isConsultor: true
          }
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {  
  const isPublic = to.meta.isPublic || false
  const isConsultor = to.meta.isConsultor || false
  let isAuthenticated = localStorage.getItem('token') ? true : false
  
  if (isAuthenticated) {
    let tokenDecoded = VueJwtDecode.decode(localStorage.getItem('token'))    
    let current_time = Date.now()/1000
    if (tokenDecoded.exp < current_time) {
      isAuthenticated = false
    }
  }
  
  if (isPublic) {
    if (isAuthenticated) {
      next('/home')
    } else {
      next()
    }
  } else {
    if (isAuthenticated) {
      next()
    } else {
      next('/')
    }
  }
  if (isAuthenticated) API.setAuthToken(localStorage.getItem('token'))
})


export default router



// WEBPACK FOOTER //
// ./src/views/index.js